//export const apiUrl = "http://192.168.1.200:80/JedietAppServices/api/";
//export const apiUrl = "http://187.232.56.102:80/JedietAppServices/api/";
export const apiUrl = "https://ohhfitappservices.azurewebsites.net/api/";
// development
//export const apiUrl = "https://localhost:44353/api/";
// production
//export const apiUrl = `http://${window.location.hostname}:80/JedietAppServices/api/`;

export async function handleResponse(response) {
    if (response.ok) {
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) return response.json();
        else return null;
    } else if (response.status === 404) {
        // Not Found, no data found.
        return false;
    } else if (response.status === 400) {
        // Bad Request, server-side validation error occurred.
        // Server side validation returns a string error message, so parse as text instead of json.
        const error = await response.text();
        debugger;
        throw new Error(error);
    } else if (response.status === 500) { 
        // Server side error.
        const error = await response.text();
        debugger;
        throw new Error(error);
    }
    debugger;
    throw new Error("Network response was not ok.");
}

// to do: In a real app, would likely call an error logging service.
export function handleError(error) {
    // eslint-disable-next-line no-console
    debugger;
    console.error("API call failed. " + error);
    throw error;
}

export async function postAsync(url, data) {
    try {
        let result = await fetch(url, {
            method: "POST",
            headers: { "content-type": "application/json" },
            body: JSON.stringify(data)
        });
        return handleResponse(result);
    } catch (error) {
        handleError(error);
    }
}

export async function putAsync(url, dataId, data) {
    try {
        let result = await fetch(`${url}/${dataId}`, {
            method: "PUT",
            headers: { "content-type": "application/json" },
            body: JSON.stringify(data)
        });
        return handleResponse(result);
    } catch (error) {
        handleError(error);
    }
}

export async function getAsync(url, dataId) {
    try {
        let result = await fetch(`${url}/${dataId}`);
        return handleResponse(result);
    } catch (error) {
        handleError(error);
    }
}

export async function getAllAsync(url) {
    try {
        let result = await fetch(url);
        return handleResponse(result);
    } catch (error) {
        handleError(error);
    }
}

export async function deleteAsync(url, dataId) {
    try {
        let result = await fetch(`${url}/${dataId}`, {
            method: "DELETE",
            headers: { "content-type": "application/json" }
        });
        debugger;
        return handleResponse(result);
    } catch (error) {
        debugger;
        handleError(error);
    }
}
